export const ROUTE_PATHS = {
  HOME: "/",
  PASSWORD_RESET: "/password-reset",
  EMAIL_VERIFICATION: "/email-verification",
  PROFILE: "/profile",
  DASHBOARD: "/dashboard",
  SEARCH_FOOD: "/searchFood",
  MY_FOODS: "/myFoods",
  PROGRESS: "/progress",
};
